var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9c9d9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14 2h-8c-.53043 0-1.03914.21071-1.41421.58579-.37508.37507-.58579.88378-.58579 1.41421v16c0 .5304.21071 1.0391.58579 1.4142.37507.3751.88378.5858 1.41421.5858h12c.5304 0 1.0391-.2107 1.4142-.5858s.5858-.8838.5858-1.4142v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 2v6h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 13h-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 17h-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 9h-1-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFile);
export default __webpack_public_path__ + "static/media/textFile.edf02af40b08872b438e85118ae2141e.svg";
export { ForwardRef as ReactComponent };